import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function DreamSection() {
  return <section className="py-20 md:py-28 px-6 bg-base" data-id="element-194">
      <div className="max-w-copy mx-auto" data-id="element-195">
        {/* Section label */}
        <FadeIn data-id="element-196">
          <div className="flex items-center gap-4 mb-16" data-id="element-197">
            <div className="h-px bg-border-accent flex-grow" data-id="element-198" />
            <span className="font-ui text-xs font-semibold tracking-widest uppercase text-accent-primary" data-id="element-199">
              ◆ The Promise ◆
            </span>
            <div className="h-px bg-border-accent flex-grow" data-id="element-200" />
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-201">
          <h2 className="font-display text-3xl md:text-5xl font-bold text-text-primary mb-14 text-center leading-tight" data-id="element-202">
            What Reading This Gives You
          </h2>
        </FadeIn>

        <div className="space-y-8 font-body text-lg leading-relaxed text-text-secondary" data-id="element-203">
          {/* Scene-setting — the "imagine" moment */}
          <FadeIn delay={0.15} data-id="element-204">
            <p className="font-display text-xl md:text-2xl italic text-text-primary leading-relaxed" data-id="element-205">
              Imagine finishing the last page of this book and finally feeling
              like you understand.
            </p>
          </FadeIn>

          {/* The pivot — escalation */}
          <FadeIn delay={0.2} data-id="element-206">
            <p data-id="element-207">Not just what happened on September 10th.</p>
          </FadeIn>

          <FadeIn delay={0.25} data-id="element-208">
            <p className="font-display text-2xl md:text-3xl font-bold text-text-primary py-2" data-id="element-209">
              But why it happened.
            </p>
          </FadeIn>

          {/* The depth — what the book reveals */}
          <FadeIn delay={0.3} data-id="element-210">
            <p data-id="element-211">
              The years of cultural pressure that built up to that moment. The
              institutions that looked the other way. The digital landscape that
              amplified division instead of dialogue. The voices that were
              already being chipped away — one deplatforming, one cancellation,
              one silenced debate at a time.
            </p>
          </FadeIn>

          {/* Key quote — blockquote treatment */}
          <FadeIn delay={0.35} data-id="element-212">
            <div className="border-l-4 border-accent-primary bg-surface p-6 md:p-8 my-12" data-id="element-213">
              <p className="font-display text-xl md:text-2xl italic text-text-primary leading-relaxed m-0" data-id="element-214">
                Reading this book means never again being the person who only
                knows the headline.
              </p>
            </div>
          </FadeIn>

          {/* Identity close — who you become */}
          <FadeIn delay={0.4} data-id="element-215">
            <p className="text-text-primary font-medium" data-id="element-216">
              It means being the person in the room who understands the full arc
              of the story — and why it matters for everyone who believes that
              ideas should be fought with better ideas, not with violence.
            </p>
          </FadeIn>

          {/* CTA in card */}
          <FadeIn delay={0.45} data-id="element-217">
            <div className="flex flex-col items-center mt-14 bg-surface border border-border-default rounded-sm p-10 text-center" data-id="element-218">
              <p className="font-display text-xl italic text-text-secondary mb-6" data-id="element-219">
                Be the one who knows the full story.
              </p>
              <Button href="#offer" className="w-full md:w-auto text-sm md:text-base" data-id="element-220">
                Get The Memorial Edition &rarr;
              </Button>
              <p className="font-ui text-xs text-text-muted mt-4 tracking-wide" data-id="element-221">
                170 pages. Instant access. Yours forever.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}